$(document).ready(function () {
  $(document).on("change", "#variant-id", function () {
    let variant_id = this.value,
      variant_image = $('.image-variant[data-variant="' + variant_id + '"]');

    variant_image.show();
  });
});

var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = "_blank";
    links[i].rel = "noreferrer noopener";
  }
}
